import { useEffect, useState } from 'react'
import whatwe1 from '../../assets/About/whatwe-1.avif'
import whatwe2 from '../../assets/About/whatwe-2.avif'
import whatwe3 from '../../assets/About/whatwe-3.avif'
import whatwe4 from '../../assets/About/whatwe-4.avif'
import { motion } from 'framer-motion'

export default function Whatwe() {

  const cards = [{
    images: whatwe1,
    title: 'Digital Product Platforms',
    desc: 'Scalable software products built around real business workflows, designed for performance, flexibility, and long-term growth.',
    id: 1
  },
  {
    images: whatwe2,
    title: 'Enterprise Web & Mobile Systems',
    desc: 'Reliable applications engineered to support operations, communication, and service delivery across devices.',
    id: 2
  },
  {
    images: whatwe3,
    title: 'Automation & Intelligence',
    desc: 'Smart digital systems that streamline processes, reduce manual work, and enable better business decisions.',
    id: 3
  },
  {
    images: whatwe4,
    title: 'Connected & IoT Technologies',
    desc: 'Integrated hardware and software solutions that deliver real-time monitoring, control, and operational visibility.',
    id: 4
  }
  ]


  const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const media = window.matchMedia("(max-width: 639px)");
      setIsMobile(media.matches);

      const handler = (e) => setIsMobile(e.matches);
      media.addEventListener("change", handler);

      return () => media.removeEventListener("change", handler);
    }, []);

    return isMobile;
  };

  const isMobile = useIsMobile();

  if (isMobile) {
    return (

      <section>
        <div className="mx-auto max-w-7xl px-8 md:px-6">

          <h2 className="font-bold text-2xl md:text-3xl lg:text-4xl my-6">
            SAN Group of Companies
          </h2>

          <p className="font-secondary text-black font-medium text-base md:text-lg lg:text-xl leading-relaxed py-4">
            Our solutions cover the full digital ecosystem:
          </p>
          <div className='flex flex-wrap gap-3'>
            {cards.map(cars => (
              <div className="relative group w-[350px] h-[400px] rounded-2xl overflow-hidden my-5" key={cars.id}>
                <img
                  src={cars.images}
                  alt="Discover Business Requirements"
                  className="w-full h-full object-cover"
                  onContextMenu={(e) => e.preventDefault()}
                  draggable={false}
                />
                <div className="
      pointer-events-none
      absolute inset-0
      bg-gradient-to-t
      from-black/60 via-black/20 to-transparent
      opacity-0
      group-hover:opacity-100
      transition-opacity duration-300
    " />

                <motion.div
                  className="absolute bottom-0 left-0 right-0 bg-white/60 backdrop-blur-sm px-3 py-3 m-3 rounded-2xl"
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{
                    duration: 0.5,
                    ease: "easeOut"
                  }}
                >
                  <p className="font-medium text-xl text-black py-1">
                    {cars.title}
                  </p>

                  <motion.p
                    className="text-lg text-gray-800 mt-1"
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{
                      duration: 0.4,
                      delay: 0.1
                    }}
                  >
                    {cars.desc}
                  </motion.p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-8 md:py-12  px-4 sm:px-6 lg:px-24 ">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-semibold text-5xl text-black tracking-[0.7px] py-8">What we create</h2>
        <p className='text-base text-gray-600 px-3 py-4 '>Our solutions cover the full digital ecosystem:</p>

        <div className="flex md:flex-row flex-col md:gap-[1px] gap-4">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              className="relative group cursor-pointer overflow-hidden "
              initial="rest"
              animate="rest"
              whileHover="hover"
              variants={{
                rest: { width: 400, height: 584 },
                hover: { width: 521, height: 584 }
              }}
              transition={{ type: "spring", stiffness: 120, damping: 15 }}
            >
              {/* IMAGE */}
              <img
                src={card.images}
                alt={card.title}
                className="w-full h-full object-cover"
                onContextMenu={(e) => e.preventDefault()}
                draggable={false}
              />

              {/* GRADIENT OVERLAY */}
              <div className="
      pointer-events-none
      absolute inset-0
      bg-gradient-to-t
      from-black/60 via-black/20 to-transparent
      opacity-0
      group-hover:opacity-100
      transition-all duration-300
    " />

              {/* CONTENT */}
              <motion.div
                className="
        absolute bottom-5 m-8 px-5 py-10
        rounded-2xl
        bg-transparent
        group-hover:bg-black/30
        group-hover:backdrop-blur-sm
        transition-all duration-300
        max-w-[90%]
      "
              >
                {/* TITLE */}
                <motion.h4
                  variants={{
                    rest: {
                      y: 0,
                      fontSize: "1.5rem", // text-2xl
                    },
                    hover: {
                      y: -12,
                      fontSize: "1.875rem", // text-3xl
                    },
                  }}
                  transition={{
                    duration: 0.35,
                    ease: "easeOut",
                  }}
                  className="transition-all
          font-medium  text-white
        "
                >
                  {card.title}
                </motion.h4>

                {/* DESCRIPTION */}
                <motion.p
                  variants={{
                    rest: { y: 12, opacity: 0 },
                    hover: { y: 0, opacity: 1 }
                  }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  className="font-secondary text-base text-white mt-3 overflow-hidden "
                >
                  {card.desc}
                </motion.p>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

